import React, { useState } from 'react'

export default function FormTextarea({id, label, placeholder, setText, hasInfo=false, infoContent=null}) {
  const [showInfo, setShowInfo] = useState(false);
  return (
    <div className='formTextarea'>
      <div className='form_infoDiv'>
        {hasInfo ? <div className="form_info" onMouseEnter={()=>{setShowInfo(true)}} onMouseLeave={()=>{setShowInfo(false)}}>
          ?
          {showInfo ? <div className="form_infoContent">{infoContent}</div> : null}
        </div> : null}
      </div>
        <label htmlFor={id}>{label}</label>
        <textarea id={id} placeholder={placeholder} onChange={(e)=>{setText(e.target.value)}}></textarea>
    </div>
  )
}
